<template>
	<div>
		<k-btn flat size="xs" @click="tag_dialog = !tag_dialog"><k-icon small>edit</k-icon></k-btn>
		<k-dialog offset-y :close-on-content-click="false" :nudge-width="150" v-model="tag_dialog">
  			<div class="ks-floating-menu">
	  			<tag-editor :event_uuid="event_uuid" :uuid="uuid" v-on:save="tag_dialog=false" @close="tag_dialog=false"></tag-editor>
	  		</div>
	  	</k-dialog>
	</div>
</template>

<script>

import TagEditor from '@/components/events/tags/Editor.vue'

export default {
	props: ["event_uuid", "uuid"],
	components: {
		TagEditor
	},
	data () {
		return {
				tag_dialog: false
			}
	},
}
</script>
